import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import Button from '../Button';
import Icon from '../Icon';
import './styles.css';

const messages = defineMessages({
  toggleSidebar: {
    id: 'app.searchToggle.buttonLabel',
    defaultMessage: 'Toggle search',
  },
});
const SearchToggleButton = ({ intl, className, onClick }) => (
  <Button
    basic
    className={className}
    icon
    styleName="search-toggle"
    aria-label={intl.formatMessage(messages.toggleSidebar)}
    onClick={onClick}
  >
    <Icon name="search" aria-hidden="true" size="large" />
  </Button>
);
SearchToggleButton.propTypes = {
  className: PropTypes.string,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default injectIntl(SearchToggleButton);
